export default __webpack_public_path__ + "static/media/nav-back-button.0cdf0b43.svg";